import { Text, Heading, Img } from "./..";
import React from "react";

export default function UserProfile({
    startDate, endDate, title, universityName, greetingText, tags, imgSrc,
    ...props
}) {
    return (
        <div
            {...props}
            className={`${props.className} grid grid-cols-8 gap-8 bg-blue_gray-800 rounded-[50px] min-h-96 `}
        >
            {/* Left Section with Image and Text */}
            <div className="col-span-6 grid grid-cols-1 sm:grid-cols-3 p-6 md:p-8 gap-y-6">
                <div className="flex  justify-start items-center gap-6">
                    <Img
                        src={imgSrc}
                        alt="Profile"
                        className="h-[100px] w-[100px] rounded-[50px] object-cover"
                    />
                    <div>
                        <Heading as="h1" className="text-[40px] font-bold text-white-a700 sm:text-[34px]">
                            {title}
                        </Heading>
                        <Heading size="headingxs" as="h5" className="text-[23px] font-bold text-slate-300 sm:text-[19px]">
                            {universityName}
                        </Heading>
                    </div>


                </div>

                <div className="flex flex-col justify-center sm:col-span-2">


                        <Text size="textxs" as="p" className="text-[24px] font-normal text-white-a700 sm:text-[20px] mt-2">
                            {greetingText}
                        </Text>
                </div>
                <div className="flex gap-4">
                    {tags?.map(tag => (
                        <div className="bg-orange-400 py-2 px-3 font-bold rounded-[50px] w-min h-min text-gray-50">
                            {tag}
                        </div>
                    ))}
                </div>
            </div>

            {/* Right Section with Dates */}
            <div className="col-span-2 flex flex-col items-center justify-center gap-6 bg-blue_gray-900 rounded-[50px] p-6">
                <Heading as="h1" className="text-center text-[40px] font-bold text-orange-400 sm:text-[34px]">
                    {startDate}
                </Heading>
                <Heading as="h1" className="text-center text-[40px] font-bold text-orange-400 sm:text-[34px]">
                    {endDate}
                </Heading>
            </div>
        </div>
    );
}
